export default function Footer() {
  return (
    <footer className="admin-footer">
      <span>VVR ERP · Module 14 — Reports &amp; Dashboards</span>
      <span className="opacity-75">
        Figures are computed on read. Dates and date boundaries are IST (Asia/Kolkata, UTC+05:30).
      </span>
    </footer>
  );
}
